import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export const getGameScoreboard = async (gameId) => {
  const { data } = await req(ENDPOINTS.GAMES.GET_GAME_SCOREBOARD(gameId))
  if (!data) {
    return []
  }
  // Sort events by occurred_at — the API may return them out of chronological order
  if (data.events) {
    data.events = [...data.events].sort(
      (a, b) =>
        new Date(a.occurred_at).getTime() - new Date(b.occurred_at).getTime()
    )
  }
  return data
}

export const getGameSettings = async (gameId) => {
  const { data } = await req(ENDPOINTS.GAMES.GET_GAME_SETTINGS(gameId))
  return data || null
}

// Returns the raw response (wrapped in `{ data, meta }`) for callers that
// rely on the historical ScoringContext shape — `useScoringContextSettings`
// reads `settings?.settings?.game?.require_officials`, which only resolves
// when the wrapper is preserved. Keep this distinct from `getGameSettings`,
// which unwraps `data`.
export const getGameSettingsRaw = (gameId) =>
  req(ENDPOINTS.GAMES.GET_GAME_SETTINGS(gameId))

export const getGameTimeline = async (gameId) => {
  const { data } = await req(ENDPOINTS.GAMES.GET_GAME_TIMELINE(gameId))
  return {
    goals: data?.goals || [],
    shots: data?.shots || [],
    goalieChanges: data?.goalieChanges || data?.goalie_changes || [],
    periods: data?.periods || [],
  }
}
